<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row wrap>
          <div class="text-center">
            <h1 class="display-3 font-weight-bold">Almost Done!</h1>
            <h1 class="body-1 font-weight-thin">
              Here are the changes you made and items you selected.
            </h1>
          </div>
        </v-layout>
        <v-layout class="mt-3" column v-if="feature.length !== 0">
          <h1 class="display-1">Feature</h1>
          <v-container>
            <v-layout row wrap v-for="row in feature">
              <div>{{ row.feature }}</div>
              <v-spacer> </v-spacer>
              <div>{{ row.price | currency }}</div>
            </v-layout>
          </v-container>
        </v-layout>
        <v-layout class="mt-3" column v-if="order.length !== 0">
          <h1 class="display-1">Cart</h1>
          <v-container>
            <v-layout row wrap v-for="row in order">
              <div>{{ row.order }}</div>
              <v-spacer> </v-spacer>
              <div>{{ row.price | currency }}</div>
            </v-layout>
            <v-divider> </v-divider>
            <v-layout row wrap>
              <div class="font-weight-medium">Total</div>
              <v-spacer> </v-spacer>
              <div class="font-weight-medium">{{ total | currency }}</div>
            </v-layout>
          </v-container>
        </v-layout>
        <div v-if="!isInvoiceCreated">
          <v-layout class="mt-5" align-center="align-center" justify-center row>
            <div>
              By placing order you are authorizing us to charge your card for
              {{ total | currency }}.
            </div>
          </v-layout>
          <v-layout class="mt-5" align-center="align-center" justify-center row>
            <v-btn color="info" :disabled="isloading" text large @click="cancel">Cancel</v-btn>
            <v-btn color="info" :loading="isloading" large dark="dark" @click="save()"
              >Place Order</v-btn
            >
          </v-layout>
        </div>
        <div v-if="Card.isInvoiceCharge">
          <v-layout class="mt-5" align-center="align-center" justify-center column>
            <div class="display-1">Order was place successfully</div>
            <div class="subheading mt-2 red--text">{{ Card.cardMessage }}</div>
          </v-layout>
          <v-layout class="mt-5" align-center="align-center" justify-center row>
            <v-btn color="info" :disabled="isloading" text large @click="paylater">Pay later</v-btn>
            <v-btn color="info" :loading="isloading" large dark="dark" @click="addCard"
              >Add another Card</v-btn
            >
          </v-layout>
        </div>
      </v-container>
      <CreditCard
        :cardDialog="cardDialog"
        @getCard="collectInvoice(location, invoiceCreated)"
        @close="cardDialog = false"
        markItDefault="true"
      >
      </CreditCard>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import signUpService from "../../service";
import invoiceService from "../../../Invoice/service";
import CreditCard from "../../../Invoice/components/CreditCard";

export default {
  data() {
    return {
      cardDialog: false,
      Card: {
        isInvoiceCharge: false,
        cardMessage: null
      },
      isloading: false,
      isInvoiceCreated: false,
      taxRate: 0,
      taxAmount: 0,
      totalAmount: 0,
      invoiceCreated: []
    };
  },
  methods: {
    ...mapActions("location", ["removeDeal"]),
    addCard() {
      this.cardDialog = true;
    },
    paylater() {
      this.removeDeal();
    },
    async save() {
      await Promise.all(
        this.states.map(row => {
          if (this.location.stateID === row.stateID) {
            this.taxRate = row.taxCollect;
          }
        })
      );

      var invoiceData = {
        taxAmount: 0,
        taxRate: this.taxRate,
        invoiceAmount: 0,
        storeID: this.location.storeID,
        userID: 1,
        fullName: "Online Customer",
        invoiceDetails: []
      };

      await Promise.all(
        this.order.map(async ord => {
          // console.log('here in order', this.order)

          if (ord.order === "Hardware") {
            this.hardware.map(row => {
              if (row.order > 0) {
                row["rate"] = row.amount;
                row["total"] = row.amount * row.order;
                row["qty"] = row.order;
                this.totalAmount += row.total;
                invoiceData.invoiceDetails.push(row);
              }
              if (this.taxRate !== 0) {
                this.taxAmount = (this.taxRate * this.totalAmount) / 100;
              }
            });
          }

          if (ord.order === "Promotion") {
            invoiceData.invoiceDetails.push({
              qty: 1,
              rate: ord.price,
              productID: 52,
              productDetail: ord.detail,
              taxAmount: 0,
              isTax: false,
              taxRate: 0,
              total: ord.price
            });
          }
        })
      );

      invoiceData.taxAmount = this.taxAmount;
      invoiceData.invoiceAmount = this.totalAmount;

      await this.createInvoice(invoiceData).then(result => {
        this.invoiceCreated = result.data.data.invoice;
        this.isInvoiceCreated = true;
      });

      await this.collectInvoice(this.location, this.invoiceCreated).then(result => {
        console.log("collect invoice", result);
        if (result.code === 200) {
          this.removeDeal();
        } else {
          this.$swal("Payment", result.data.data, "error").then(() => {
            this.Card.cardMessage = result.data.data;
            this.Card.isInvoiceCharge = true;
          });
        }
      });

      // this.removeDeal()
    },
    createInvoice(data) {
      return invoiceService.createInvoice(data).then(result => {
        return result;
      });
    },
    async collectInvoice(store, data) {
      let card = null;
      await invoiceService.getStripeCard(store.storeID).then(result => {
        card = result.data.default_source;
      });
      let userData = {
        cardId: card
      };
      return invoiceService
        .collectInvoice(data.invoiceID, userData)
        .then(invoice => {
          return invoice;
        })
        .catch(error => {
          return error;
        });
    },
    cancel() {
      this.$router.push({ path: `/location` });
    }
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "states"]),
    ...mapGetters("location", [
      "order",
      "feature",
      "plans",
      "hardware",
      "store",
      "card",
      "hardwareTotal",
      "shipping",
      "signUp",
      "location"
    ]),
    total() {
      let total = 0;
      this.order.map(row => {
        total = total + row.price;
      });
      return total;
    }
  },
  created() {
    if (this.feature.length > 0) {
      let changeFeature = [];
      this.feature.forEach(row => {
        changeFeature.push(row.id);
      });
      signUpService.addFeature(this.location.storeID, { feature: changeFeature }).then(result => {
        return result;
      });
    }
    console.log("feature", this.feature);
    if (this.order.length === 0) {
      this.removeDeal();
    }
  },
  components: {
    CreditCard
  }
};
</script>

<style scoped></style>
